// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.store/css-loader@7.1.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.store/css-loader@7.1.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  font-size: 16px; /* 锁定基准，忽略系统设置 */
  -webkit-text-size-adjust: 100%; /* 禁止iOS Safari自动调整 */
  text-size-adjust: 100%; /* 标准属性 */
}

@supports (bottom: env(safe-area-inset-bottom)){

    :root {
      --sat: env(safe-area-inset-top);
      --sar: env(safe-area-inset-right);
      --sab: env(safe-area-inset-bottom);
      --sal: env(safe-area-inset-left);
    }
    /* padding-bottom: env(safe-area-inset-bottom)!important; */
  
}


@supports (bottom: constant(safe-area-inset-bottom)){

  :root {
    --sat: constant(safe-area-inset-top);
    --sar: constant(safe-area-inset-right);
    --sab: constant(safe-area-inset-bottom);
    --sal: constant(safe-area-inset-left);
  }
  /* padding-bottom: env(safe-area-inset-bottom)!important; */

}

input[aria-hidden=true]{
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,eAAe,EAAE,gBAAgB;EACjC,8BAA8B,EAAE,qBAAqB;EACrD,sBAAsB,EAAE,SAAS;AACnC;;AAEA;;IAEI;MACE,+BAA+B;MAC/B,iCAAiC;MACjC,kCAAkC;MAClC,gCAAgC;IAClC;IACA,2DAA2D;;AAE/D;;;AAGA;;EAEE;IACE,oCAAoC;IACpC,sCAAsC;IACtC,uCAAuC;IACvC,qCAAqC;EACvC;EACA,2DAA2D;;AAE7D;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":["html {\n  font-size: 16px; /* 锁定基准，忽略系统设置 */\n  -webkit-text-size-adjust: 100%; /* 禁止iOS Safari自动调整 */\n  text-size-adjust: 100%; /* 标准属性 */\n}\n\n@supports (bottom: env(safe-area-inset-bottom)){\n\n    :root {\n      --sat: env(safe-area-inset-top);\n      --sar: env(safe-area-inset-right);\n      --sab: env(safe-area-inset-bottom);\n      --sal: env(safe-area-inset-left);\n    }\n    /* padding-bottom: env(safe-area-inset-bottom)!important; */\n  \n}\n\n\n@supports (bottom: constant(safe-area-inset-bottom)){\n\n  :root {\n    --sat: constant(safe-area-inset-top);\n    --sar: constant(safe-area-inset-right);\n    --sab: constant(safe-area-inset-bottom);\n    --sal: constant(safe-area-inset-left);\n  }\n  /* padding-bottom: env(safe-area-inset-bottom)!important; */\n\n}\n\ninput[aria-hidden=true]{\n  display: none !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
